import React, { ReactElement } from 'react'
import AddMoreIcon from '../assets/AddMoreIcon'

function ButtonAddMore({
  label = '',
  handleClick,
  disabled,
  type,
}: {
  label: string
  handleClick: () => void
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
}): ReactElement {
  return (
    <button
      className="btnUnstyled dInlineFlex alignItemsCenter pointer mb2 mb0md"
      onClick={() => handleClick()}
      disabled={disabled}
      type={type}
    >
      <AddMoreIcon className={`mr15 ${disabled ? '' : 'textPrimary'}`} />
      <span
        className={`${
          disabled ? 'textPrimaryDark' : 'textPrimary'
        } fontWeightBold`}
      >
        {label}
      </span>
    </button>
  )
}

export default ButtonAddMore
